import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { TekiTreeCacheViewModel } from './tekiTreeCacheViewModel';

export class TekiTreeCacheContainer extends MasterDataContainer<TekiTreeCacheViewModel> {
    constructor(models: Array<TekiTreeCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
